import { useSelector } from "react-redux";
import { StateExtended } from "../../interfaces/StateExtended";

export function useAppEventGameListSelector() {
  const eventGameList = useSelector((state: StateExtended) => state.event.getEventGameList);
  return eventGameList;
}

export function useAppEventGameDetailSelector() {
  const eventGameDetails = useSelector((state: StateExtended) => state.event.getEventGameDetails);
  return eventGameDetails;
}

export function useAppEventStatusMessageSelector() {
  const statusMessage = useSelector((state: StateExtended) => state.event.getEventStatusMessage);
  return statusMessage;
}

export const useAppGameLoginRequiredSelector = () => {
  const login_required = useSelector((state: StateExtended) => state.event.login_required);
  return login_required;
};

export function useAppEventLeaderBoardSelector() {
  const leaderBoard = useSelector((state: StateExtended) => state.event.getLeaderBoard);
  return leaderBoard;
}

export function useAppTvImageSelector() {
  const tvImage = useSelector((state: StateExtended) => state.event.getTvImageDetails);
  return tvImage;
}

export function useAppCmsListSelector() {
  const cmsList = useSelector((state: StateExtended) => state.event.cmsList);
  return cmsList;
}
export const useAppGameDetailsSelector = () => {
  const gameDetails = useSelector((state: StateExtended) => state.event.gameDetails);
  return gameDetails;
};
